import {useMemo} from "react";
import {useLocation} from "react-router";
import useSession from "../../../hooks/use-session.js";
import useDevMenu from "./use-dev-menu.js";
import {buildMenu, injectVmsCardsIntoCards, sessionToContext} from "../utils/menu-filter.js";
import sentryMenu from "../resources/sentry-menu.js";
import dispatchMenu from "../resources/dispatch-menu.js";
import submenu from "../resources/submenu.js";

const useAppMenu = () => {
    const {data: session} = useSession();
    const {pathname} = useLocation();
    const devEnabled = useDevMenu();
    const target = pathname.startsWith("/despacho") ? "dispatch" : "sentry";

    return useMemo(() => {
        const ctx = sessionToContext(session);
        const baseTree = target === "dispatch" ? dispatchMenu.menu : sentryMenu.menu;
        const tree = target === "dispatch" ? baseTree : injectVmsCardsIntoCards(baseTree, ctx.vmsCards);

        return {
            target,
            menu: buildMenu(tree, ctx, target),
            shortcuts: buildMenu(submenu, ctx, target),
        };
    }, [session, target, devEnabled]);
};

export default useAppMenu;
